import './src/assets/styles/main.scss'
import wrapWithProvider from './src/wrap-with-provider'
export const wrapRootElement = wrapWithProvider
export { wrapPageElement } from './gatsby-ssr'
